





import { useState } from "react";
import { createPortal } from "react-dom";
import { createChatGroupApi } from "../../app/api";

export default function CreateGroupModal({ employees, onClose, onGroupCreated }) {
  const [groupName, setGroupName] = useState("");
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [loading, setLoading] = useState(false);

  const toggleMember = (id) => {
    setSelectedMembers((prev) =>
      prev.includes(id)
        ? prev.filter((m) => m !== id)
        : [...prev, id]
    );
  };

  const handleCreate = async () => {
    if (!groupName.trim()) {
      return alert("Group name is required");
    }

    if (selectedMembers.length === 0) {
      return alert("Please select at least one member");
    }

    setLoading(true);
    try {
      const res = await createChatGroupApi({
        name: groupName,
        members: selectedMembers,
      });

      if (res?.success) {
        onGroupCreated();
        onClose();
      } else {
        alert(res?.message || "Failed to create group");
      }
    } catch (err) {
      console.error("Create group error:", err);
      alert("Failed to create group. Are you an admin?");
    } finally {
      setLoading(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-gray-900 border border-white/20 p-6 rounded-2xl w-[400px] text-white">
        
        {/* TITLE */}
        <h3 className="text-xl font-bold mb-4">Create Group</h3>

        {/* GROUP NAME INPUT */}
        <input
          className="w-full bg-white/10 px-4 py-2 rounded-lg mb-4 outline-none border border-transparent focus:border-purple-500"
          placeholder="Group Name"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
        />

        {/* MEMBERS LIST */}
        <div className="max-h-[300px] overflow-y-auto mb-4 border border-white/10 rounded-lg p-2">
          {employees.length === 0 ? (
            <p className="text-sm text-center opacity-50">No employees found</p>
          ) : (
            employees.map((emp) => (
              <div
                key={emp.id}
                className="flex items-center gap-3 p-2 hover:bg-white/10 rounded-lg cursor-pointer"
                onClick={() => toggleMember(emp.id)}
              >
                <input
                  type="checkbox"
                  checked={selectedMembers.includes(emp.id)}
                  readOnly
                  className="w-4 h-4"
                />
                <span className="text-sm">
                  {emp.first_name} {emp.last_name}
                </span>
              </div>
            ))
          )}
        </div>

        {/* ACTION BUTTONS */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm transition"
          >
            Cancel
          </button>

          <button
            onClick={handleCreate}
            disabled={loading}
            className="px-4 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-sm transition disabled:opacity-50"
          >
            {loading ? "Creating..." : "Create"}
          </button>
        </div>

      </div>
    </div>,
    document.body
  );
}








// import { useState } from "react";
// import { createPortal } from "react-dom";
// import axios from "axios";
// import Cookies from "js-cookie";

// const API_BASE_URL = "http://192.168.1.16:5555/api"; 

// export default function CreateGroupModal({ employees, onClose, onGroupCreated }) {
//   const [groupName, setGroupName] = useState("");
//   const [selectedMembers, setSelectedMembers] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const toggleMember = (id) => {
//     setSelectedMembers((prev) =>
//       prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id]
//     );
//   };

//   const handleCreate = async () => {
//     if (!groupName.trim()) return alert("Group name is required");
    
//     setLoading(true);
//     try {
//       const token = Cookies.get("token") || localStorage.getItem("token");
//       await axios.post(
//         `${API_BASE_URL}/chat/groups`,
//         { name: groupName, members: selectedMembers },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       onGroupCreated();
//       onClose();
//     } catch (err) {
//       console.error(err);
//       alert("Failed to create group. Are you an admin?");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return createPortal(
//     <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 backdrop-blur-sm">
//       <div className="bg-gray-900 border border-white/20 p-6 rounded-2xl w-[400px] text-white">
//         <h3 className="text-xl font-bold mb-4">Create Group</h3>
        
//         <input
//           className="w-full bg-white/10 px-4 py-2 rounded-lg mb-4 outline-none border border-transparent focus:border-purple-500"
//           placeholder="Group Name"
//           value={groupName}
//           onChange={(e) => setGroupName(e.target.value)}
//         />

//         <div className="max-h-[300px] overflow-y-auto mb-4 border border-white/10 rounded-lg p-2">
//           {employees.map((emp) => (
//             <div key={emp.id} className="flex items-center gap-3 p-2 hover:bg-white/10 rounded-lg cursor-pointer" onClick={() => toggleMember(emp.id)}>
//               <input
//                 type="checkbox"
//                 checked={selectedMembers.includes(emp.id)}
//                 readOnly
//                 className="w-4 h-4"
//               />
//               <span className="text-sm">{emp.first_name} {emp.last_name}</span>
//             </div>
//           ))}
//         </div>

//         <div className="flex justify-end gap-3">
//           <button onClick={onClose} className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 text-sm transition">Cancel</button>
//           <button onClick={handleCreate} disabled={loading} className="px-4 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-sm transition disabled:opacity-50">
//             {loading ? "Creating..." : "Create"}
//           </button>
//         </div>
//       </div>
//     </div>,
//     document.body
//   );
// }
